export const PRIMARY = '#121a3d';
export const PRIMARY_LIGHT = '#F3F7FC';
export const PRIMARY_DARK = '#1C1A52';
export const SECONDARY = '#FD3B61';
export const TEXT = '#4f4f4f';
export const LINK = '#0091FF';
export const DANGER = '#E02020';
export const SUCCESS = '#4caf50';
export const WARNING = '#ffd12c';
export const BG_LIGHT_BLUE = '#f1f4f7';
export const TITLE_GREY = '#868686';
export const TEXT_DARK_GREY = '#505050';
export const TEXT_GREY = '#919191';
export const CARD_BORDER = '#CCC';
